import React from "react";
import _ from "lodash";
import Socket from "socket";
import { motion } from "framer-motion/dist/framer-motion";

import OverLT from "../../LT/screens/Over";
import TriviaSubmit from "assets/images/sbs/TriviaSubmit.png";

const Over = ({
  key,
  roomId,
  player,
  isAsker,
  sound_in,
  playAudio,
  playerInfo,
  mobile_app,
  questionObj,
  over_params,
  answers_array,
  correct_answer,
  set_has_answered
}) => {
  const answer_label = _.get(over_params, "answer_label", "Answer:");

  const handleSubmit = () => {
    playAudio(sound_in);
    const destination = "ChooseAsker";
    if (mobile_app) {
      const message = {
        action: "update-status",
        destination
      };
      window.parent.postMessage(message, "*");
    } else {
      const data = {
        action: "update-status",
        roomId: roomId,
        destination
      };
      Socket.sendMessage(data);
    }
  };
  const divVariants = {
    hidden: {},
    visible: {},
    exit: {}
  };
  const buttonVariants = {
    hidden: { x: "100vw" },
    visible: { x: 0 },
    exit: { x: "-100vw" }
  };
  const startButtonVariants = {
    hidden: { x: "100vw" },
    visible: { x: 0 },
    exit: { opacity: [1, 1, 0], scale: [0.9, 1.1, 0.3] }
  };
  const textVariants = {
    hidden: { opacity: 0.4, scale: 0.2 },
    visible: { opacity: 1, scale: 1 },
    exit: { opacity: 0, scale: 0.2 }
  };
  const questionTextVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { delay: 0.5 } },
    exit: { x: "-100vw" }
  };
  const imgExitVariants = {
    exit: {
      y: "-100vh",
      opacity: 0.5,
      scale: 0.7,
      transition: {
        type: "tween",
        duration: 0.5,
        opacity: { duration: 0.3 },
        scale: { duration: 0.3 },
        y: { delay: 0.3 }
      }
    }
  };

  return isAsker ? (
    <div key={key} className="container">
      <motion.div
        variants={divVariants}
        initial="hidden"
        animate="visible"
        exit="exit"
        className="Lightning-trivia-Wrapper SubmitTrivia-questionAnswer asked-question TriviaScore triviaOver"
      >
        <motion.img
          variants={imgExitVariants}
          src={TriviaSubmit}
          className="logoimage"
          alt="sbsLogo"
        />
        <motion.h2 variants={textVariants} className="mediamText whiteText">
          Great Question!
        </motion.h2>
        <motion.div
          variants={buttonVariants}
          className="questionArea mediamText darkBlueText quesPadding questionText"
        >
          <motion.p variants={questionTextVariants}>
            {questionObj?.question}
          </motion.p>
        </motion.div>
        <motion.p variants={textVariants} className="mediamText blueText m-0">
          {answer_label}
        </motion.p>
        <motion.p variants={textVariants} className="mediamText whiteText">
          {questionObj?.answers[questionObj.correct_answer]}
        </motion.p>
        <motion.button
          variants={startButtonVariants}
          onClick={handleSubmit}
          className="TriviaSmall-btn"
        >
          Start Over
        </motion.button>
      </motion.div>
    </div>
  ) : (
    <OverLT
      lts
      key={key}
      player={player}
      sound_in={sound_in}
      playAudio={playAudio}
      playerInfo={playerInfo}
      over_params={over_params}
      answers_array={answers_array}
      correct_answer={correct_answer}
      set_has_answered={set_has_answered}
    />
  );
};

export default Over;
